import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import CallToActionDecorator from 'decorators/cta/cta_decorator'

import styles from './base_button.scss'

const size = {
	small: 'size-small',
	medium: 'size-medium',
	big: 'size-big',
}

const backgroundColor = {
	transparent: 'background-transparent',
	fullWhite: 'background-border-white',
	black: 'background-black',
	gray: 'background-gray',
	'dark-gray': 'background-dark-gray',
	red: 'background-red',
	green: 'background-green',
	blue: 'background-blue',
	'border-blue': 'border-blue',
	'border-green': 'border-green',
	'animated-green': 'animated-green',
	'border-red': 'border-red',
	'border-gray': 'border-gray',
	purple: 'background-purple',
	gold: 'background-gold',
	'black-border-blue': 'black-border-blue',
	'black-border-white': 'black-border-white',
}

const fontColor = {
	transparent: 'font-transparent',
	white: 'font-white',
	black: 'font-black',
	gray: 'font-gray',
	red: 'font-red',
	green: 'font-green',
	blue: 'font-blue',
}

class BaseButton extends Component {

	render() {
		return (
			<div styleName={classNames({
				base: true,
				[size[this.props.size]]: true,
				[backgroundColor[this.props.bgColor]]: true,
				[fontColor[this.props.fontColor]]: true,
				pill: this.props.pill,
				'base--focus': this.props.isInFocus && this.props.focus,
			})}
			tabIndex={this.props.tabIndex}
			autoFocus={this.props.autoFocus} >
				<div styleName="layer-transparent"></div>
				<div styleName="layer-container">
					{ this.props.children }
					<div styleName='icon'>
						{ this.props.icon }
					</div>
				</div>
			</div>
		)
	}

}

BaseButton.defaultProps = {
	bgColor: 'transparent',
	fontColor: 'transparent',
	size: 'medium',
	icon: null,
	pill: false,
	indexTab: -1,
	focus: false,
	autoFocus: false,
}

export default CallToActionDecorator(CSSModules(BaseButton, styles, {allowMultiple: true}))
